var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShare = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "share"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.1833 10.8917C16.8667 10.8917 16.6 10.65 16.5583 10.3333C16.3583 8.45 15.3417 6.74167 13.775 5.65833C13.4917 5.45833 13.425 5.075 13.6167 4.79167C13.8167 4.50833 14.2083 4.44167 14.4833 4.63333C16.35 5.925 17.55 7.95833 17.7917 10.2C17.825 10.5417 17.5833 10.85 17.2333 10.8917C17.225 10.8917 17.2 10.8917 17.1833 10.8917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.90833 10.9333C2.88333 10.9333 2.86667 10.9333 2.84167 10.9333C2.5 10.8917 2.25 10.5833 2.28333 10.2417C2.50833 8 3.7 5.975 5.54167 4.66667C5.825 4.46667 6.21667 4.53333 6.41667 4.81667C6.61667 5.1 6.55 5.49167 6.26667 5.69167C4.71667 6.78333 3.71667 8.49167 3.525 10.375C3.5 10.6917 3.225 10.9333 2.90833 10.9333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.05 18.8417C8.81667 18.8417 7.64167 18.5583 6.54167 18.0083C6.23333 17.85 6.10833 17.475 6.26667 17.1667C6.425 16.8583 6.8 16.7333 7.10833 16.8917C8.90833 17.8 11.075 17.8167 12.8917 16.9417C13.2 16.7917 13.575 16.925 13.725 17.2333C13.875 17.5417 13.7417 17.9167 13.4333 18.0667C12.3667 18.5833 11.2333 18.8417 10.05 18.8417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.05 7.03333C8.425 7.03333 7.10833 5.71667 7.10833 4.09167C7.10833 2.46667 8.425 1.15 10.05 1.15C11.675 1.15 12.9917 2.46667 12.9917 4.09167C12.9917 5.71667 11.6667 7.03333 10.05 7.03333ZM10.05 2.40833C9.11667 2.40833 8.35833 3.16667 8.35833 4.1C8.35833 5.03333 9.11667 5.79167 10.05 5.79167C10.9833 5.79167 11.7417 5.03333 11.7417 4.1C11.7417 3.16667 10.975 2.40833 10.05 2.40833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M4.025 17.225C2.4 17.225 1.08333 15.9083 1.08333 14.2833C1.08333 12.6667 2.4 11.3417 4.025 11.3417C5.65 11.3417 6.96667 12.6583 6.96667 14.2833C6.96667 15.9 5.65 17.225 4.025 17.225ZM4.025 12.5917C3.09167 12.5917 2.33333 13.35 2.33333 14.2833C2.33333 15.2167 3.09167 15.975 4.025 15.975C4.95833 15.975 5.71667 15.2167 5.71667 14.2833C5.71667 13.35 4.95833 12.5917 4.025 12.5917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M15.975 17.225C14.35 17.225 13.0333 15.9083 13.0333 14.2833C13.0333 12.6667 14.35 11.3417 15.975 11.3417C17.6 11.3417 18.9167 12.6583 18.9167 14.2833C18.9083 15.9 17.5917 17.225 15.975 17.225ZM15.975 12.5917C15.0417 12.5917 14.2833 13.35 14.2833 14.2833C14.2833 15.2167 15.0417 15.975 15.975 15.975C16.9083 15.975 17.6667 15.2167 17.6667 14.2833C17.6583 13.35 16.9083 12.5917 15.975 12.5917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_7",
    opacity: 0
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShare);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/share.009c3703da17fd82a72349c64a26a5d7.svg";